<template>
  <div>
    <custom-select
        :options="formattedAffiliates"
        v-model="selectedAffiliate"
        label="combinedText"
        @search="handleSearchInput"
        @input="switchAffiliate"
        class="custom_select"
        :clearable="false"
    ></custom-select>
    <v-progress-circular
        class="custom_select_circular"
        v-if="formattedAffiliates.length === 0"
        indeterminate
        color="primary"
        size="20"
    ></v-progress-circular>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from "@/store";
import { debounce } from 'debounce'
export default {
  props: {
    affiliates: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lastDispatchedSearch: '',
      searchInput: '',
      selectedAffiliate: null,
      filters: {
        search: "",
        affiliateV2: "V2",
      }
    };
  },
  methods: {
    ...mapActions('affiliates', ['getAffiliatesChat']),
    handleSearchInput: debounce(function(value) {
      if (value && value !== this.lastDispatchedSearch) {
        this.updateStore(value);
      }
    }, 300),
    switchAffiliate() {
      this.$emit('switch-affiliate', this.selectedAffiliate.id);
    },

    async updateStore(searchQuery) {

      if (!searchQuery) {
        this.searchInput = this.lastSuccessfulSearch;
        return;
      }

      if (searchQuery !== this.lastDispatchedSearch) {
        this.lastDispatchedSearch = searchQuery;

        this.filters.search = searchQuery;

        const response = await store.dispatch('affiliates/getAffiliatesChat', {
          payload: {
            limit: 25,
            page: 1,
            orderBy: '',
            orderDirectionAsc: false,
            filters: this.filters
          }
        });

        this.lastSuccessfulSearch = searchQuery;
      }
    }
  },
  watch: {
    activeSearch(newValue) {
      if (this.selectedAffiliate && newValue !== this.selectedAffiliate.combinedText) {
        this.updateStore(newValue);
      }
    }
  },

  computed: {
    formattedAffiliates() {
      return this.affiliates.map(affiliate => ({
        ...affiliate,
        combinedText: `${affiliate.email} (${affiliate.affNameId})`
      }));
    }
  }
};
</script>
